module.exports = __webpack_public_path__ + "img/AzadBarzinji.88b4745f.jpg";